export default __webpack_public_path__ + "static/media/Graphik-Medium.d9746847.woff";